import * as yup from 'yup';

const ipV4Regex = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;

yup.addMethod(yup.string, 'ipV4', function () {
  return this.test('ipV4', function (value) {
    const { path, createError } = this;
    return new Promise((resolve, reject) => {
      if (ipV4Regex.test(value)) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Invalid ip address' }));
      }
    });
  });
});

yup.addMethod(yup.string, 'multiselect', function () {
  return this.test('multiselect', function () {
    const { path, createError } = this;
    const value = document.getElementsByClassName('multiselect-' + path)[0]
      .options.length;
    return new Promise((resolve, reject) => {
      if (value) {
        resolve(true);
      } else {
        reject(
          createError({ path, message: 'field is required', type: 'required' })
        );
      }
    });
  });
});

const schema = yup.object().shape({
  sipserver: yup
    .string()
    .required()
    .ipV4(),
  sipport: yup
    .number()
    .required()
    .positive()
    .integer()
    .max(65535),
  password: yup.string().required(),
  voipdeviceindex: yup
    .number()
    .required()
    .positive()
    .integer()
    .min(0)
    .max(65535),
  users: yup.string().multiselect()
});

export default schema;
